<div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" style="margin: 50px 0;">
  <ng-container *ngFor="let step of steps; let i = index">

    <div class="step" *ngIf="i === 0"
      [ngClass]="{'line' : i < steps.length - 1 && visibleStepsCount === 3, 'line2': i < steps.length - 1 && visibleStepsCount === 4, 'line3' : i < steps.length - 1 && visibleStepsCount === 2}">
      <div class="step-icon" [ngClass]="{'active' : step.active, 'checked' : step.checked}">
        <p *ngIf="!step.checked">1</p> <i *ngIf="step.checked" class="fas fa-check"></i>
      </div>
      <div [ngClass]="{'active' : step.active}">{{step.name}}</div>
    </div>

    <div class="step" *ngIf="(i === 1 || i === 2) && showAdvancedPixSteps"
      [ngClass]="{'line' : i < steps.length - 1 && visibleStepsCount === 3, 'line2': i < steps.length - 1 && visibleStepsCount === 4, 'line3' : i < steps.length - 1 && visibleStepsCount === 2}">
      <div class="step-icon" [ngClass]="{'active' : step.active, 'checked' : step.checked}">
        <p *ngIf="!step.checked">{{i + 1}}</p> <i *ngIf="step.checked" class="fas fa-check"></i>
      </div>
      <div [ngClass]="{'active' : step.active}">{{step.name}}</div>
    </div>

    <div class="step" *ngIf="i >= 3"
      [ngClass]="{'line' : i < steps.length - 1 && visibleStepsCount === 3, 'line2': i < steps.length - 1 && visibleStepsCount === 4, 'line3' : i < steps.length - 1 && visibleStepsCount === 2}">
      <div class="step-icon" [ngClass]="{'active' : step.active, 'checked' : step.checked}">
        <p *ngIf="!step.checked">
          <ng-container *ngIf="showAdvancedPixSteps">
            {{ i + 1 }} </ng-container>
          <ng-container *ngIf="!showAdvancedPixSteps">
            <ng-container *ngIf="i === 3">2</ng-container> <ng-container *ngIf="i === 4">3</ng-container> </ng-container>
        </p>
        <i *ngIf="step.checked" class="fas fa-check"></i>
      </div>
      <div [ngClass]="{'active' : step.active}">{{step.name}}</div>
    </div>

  </ng-container>
</div>